import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=481bdb1b&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=481bdb1b&prod&lang=less&scoped=true"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=481bdb1b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.4_vue-template-compiler@2.7.14_webpack@5.83.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bdb1b",
  null
  
)

export default component.exports